"use client";

import { useState } from "react";
import { TextField } from "@mui/material";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  QuickFilter,
  ExportCsv,
  ExportPrint,
  ToolbarButton,
} from "@mui/x-data-grid-pro";

// these are copy pasted from here: https://mui.com/x/react-data-grid/components/toolbar/#basic-usage

type OwnerState = {
  expanded: boolean;
};

export const StyledQuickFilter = styled(QuickFilter)({
  display: "grid",
  alignItems: "center",
});

export const StyledToolbarButton = styled(ToolbarButton)<{
  ownerState: OwnerState;
}>(({ theme, ownerState }) => ({
  gridArea: "1 / 1",
  width: "min-content",
  height: "min-content",
  zIndex: 1,
  opacity: ownerState.expanded ? 0 : 1,
  pointerEvents: ownerState.expanded ? "none" : "auto",
  transition: theme.transitions.create(["opacity"]),
}));

export const StyledTextField = styled(TextField)<{
  ownerState: OwnerState;
}>(({ theme, ownerState }) => ({
  gridArea: "1 / 1",
  overflowX: "clip",
  width: ownerState.expanded ? 260 : "var(--trigger-width)",
  opacity: ownerState.expanded ? 1 : 0,
  transition: theme.transitions.create(["width", "opacity"]),
}));

export const ExportButton = () => {
  const [exportMenuOpen, setExportMenuOpen] = useState(false);
  const [exportMenuAnchor, setExportMenuAnchor] =
    useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Tooltip title="Export">
        <ToolbarButton
          ref={setExportMenuAnchor}
          id="export-menu-trigger"
          aria-controls="export-menu"
          aria-haspopup="true"
          aria-expanded={exportMenuOpen ? "true" : undefined}
          onClick={() => setExportMenuOpen(true)}
        >
          <FileDownloadIcon fontSize="small" />
        </ToolbarButton>
      </Tooltip>
      <Menu
        id="export-menu"
        anchorEl={exportMenuAnchor}
        open={exportMenuOpen}
        onClose={() => setExportMenuOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          list: {
            "aria-labelledby": "export-menu-trigger",
          },
        }}
      >
        <ExportPrint
          render={<MenuItem />}
          onClick={() => setExportMenuOpen(false)}
        >
          Print
        </ExportPrint>
        <ExportCsv
          render={<MenuItem />}
          onClick={() => setExportMenuOpen(false)}
        >
          Download as CSV
        </ExportCsv>
      </Menu>
    </>
  );
};
